import { browserApiClient, requiredApiData } from './browser-api';

export type WorldNodeReportReason =
  'private_property' | 'inaccessible' | 'unsafe' | 'missing' | 'duplicate' | 'other';

export async function reportWorldNode(nodeId: string, reason: WorldNodeReportReason) {
  const response = await browserApiClient({ mutation: true }).POST(
    '/api/v1/explore/world-nodes/{node_id}/reports',
    { params: { path: { node_id: nodeId } }, body: { reason } },
  );
  return requiredApiData(
    response.data,
    response.error,
    'Your report could not be sent. Try again.',
  );
}
